import './ModalAdicionarUnidade.css';

const ModalAdicionarUnidade = ({
    newId, setNewId,
    newName, setNewName,
    newOwnerPhone, setNewOwnerPhone,
    newAdmins, setNewAdmins,
    newPlan, setNewPlan,
    newCycle, setNewCycle,
    SUBSCRIPTION_PLANS,
    BILLING_CYCLES,
    setIsAdding,
    handleAddTenant,
    saving
}) => {
    return (
        <div className="master-modal-overlay">
            <div className="master-modal">
                <h3>Cadastrar Unidade</h3>
                <div className="m-form-group">
                    <label>Identificador Único (ID)</label>
                    <input value={newId} onChange={e => setNewId(e.target.value.toLowerCase().replace(/\s+/g, '-'))} placeholder="ex: barber-lux" />
                </div>
                <div className="m-form-group">
                    <label>Nome da Unidade</label>
                    <input value={newName} onChange={e => setNewName(e.target.value)} placeholder="Nome Comercial" />
                </div>
                <div className="m-form-group">
                    <label>WhatsApp do Responsável</label>
                    <input value={newOwnerPhone} onChange={e => setNewOwnerPhone(e.target.value)} placeholder="(11) 99999-9999" />
                </div>
                <div className="m-form-group">
                    <label>Admins (e-mails separados por vírgula)</label>
                    <input value={newAdmins} onChange={e => setNewAdmins(e.target.value)} placeholder="user@gmail.com, admin@teste.com" />
                </div>
                <div className="m-form-group">
                    <label>Plano de Assinatura</label>
                    <select value={newPlan} onChange={e => setNewPlan(e.target.value)}>
                        {Object.entries(SUBSCRIPTION_PLANS).map(([id, p]) => (
                            <option key={id} value={id}>{p.name} - R$ {p.price.toFixed(2)} ({p.limit === 999 ? 'Ilimitado' : `Até ${p.limit} barbeiros`})</option>
                        ))}
                    </select>
                </div>
                <div className="m-form-group">
                    <label>Ciclo de Faturamento</label>
                    <select value={newCycle} onChange={e => setNewCycle(e.target.value)}>
                        {BILLING_CYCLES.map((c) => (
                            <option key={c.months} value={c.months}>{c.name} {c.discount > 0 ? `(${c.discount}% de desconto)` : ''}</option>
                        ))}
                    </select>
                </div>
                <div className="m-modal-actions">
                    <button className="modal-btn secondary" onClick={() => setIsAdding(false)}>Cancelar</button>
                    <button className="modal-btn primary" onClick={handleAddTenant} disabled={saving}>
                        {saving ? 'Processando...' : 'Confirmar Cadastro'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ModalAdicionarUnidade;
